import * as React from "react";
import Box from "@mui/joy/Box";
import Button from "@mui/joy/Button";
import FormControl from "@mui/joy/FormControl";
import FormLabel from "@mui/joy/FormLabel";
import Input from "@mui/joy/Input";
import Table from "@mui/joy/Table";
import Sheet from "@mui/joy/Sheet";
import Typography from "@mui/joy/Typography";
import Chip from "@mui/joy/Chip";
import CircularProgress from "@mui/joy/CircularProgress";
// import IconButton from '@mui/material/IconButton';
import DownloadIcon from '@mui/icons-material/Download';

import SearchIcon from "@mui/icons-material/Search";

import { IReportData } from "../../utils/types";
import { useGetFetchLocationQuery, useGetRejectInoiceReportsQuery, useGetRejectMultipleMutation, useGetReportsQuery } from "../../services/invoices/InvoiceApiSlice";
import MultiSelectCheckboxDropdown from "../MultiSelectCheckdownDropbox";
import { displayOptional, formatDateTable } from "../../utils/utils";
import { apiBaseUrl, invoiceStatusOptionsEmployee } from "../../utils/constants";
import { Autocomplete, Checkbox, DialogContent, DialogTitle, IconButton, Modal, ModalDialog, Stack } from "@mui/joy";
import { start } from "repl";
import { toast } from "react-toastify";
import ClearIcon from '@mui/icons-material/Clear';
import { TextareaInput } from "../../utils/input";


const ITEMS_PER_PAGE = 10;

export default function RejectInvoiceTable() {
    const pernr = localStorage.getItem("employee_id");

    const tableHeaders: Array<{
        id: keyof IReportData | "action" | 'req_type' | 'entry_type' | 'po_num';
        label: string;
        minWidth: number;
        numeric?: boolean;
        disableSort?: boolean;
    }> = [
            // { id: "Checkbox", label: "", minWidth: 50 },
            { id: "bts_no", label: "BTS No.", minWidth: 150 },
            { id: "vendor_name", label: "Vendor Name", minWidth: 130 },
            { id: "vendor_code", label: "Vendor Code", minWidth: 130 },
            { id: "action_date", label: "Action Date", minWidth: 110 },
            { id: "created_by", label: "Created By", minWidth: 130 },
            { id: "req_type", label: "Request Type", minWidth: 130 },
            { id: "pending_with", label: "Pending With", minWidth: 110 },
            { id: "entry_type", label: "Entry Type", minWidth: 110 },
            { id: "po_num", label: "PO Number", minWidth: 110 },
            { id: "status", label: "Status", minWidth: 130 },
            // { id: "paid_on", label: "Paid On", minWidth: 130 },
            // { id: "paid_duration", label: "Paid Duration", minWidth: 130 },
        ];

    const [isOpen, setisOpen] = React.useState(false);
    const [selectedList, setSelectedList] = React.useState([]);
    const [startDate, setStartDate] = React.useState("");
    const [endDate, setEndDate] = React.useState("");
    const [locationList, setLocationList] = React.useState([]);
    const [currentPage, setCurrentPage] = React.useState(1);
    const [entries, setEntries] = React.useState([]);
    const [filterInputs, setFilterInputs] = React.useState({
        bts_no: "",
        invoice_status: [] as string[],
        vendor_code: "",
        vendor_name: "",
        location: ""
    });

    const [isRejectOpen, setIsRejectOpen] = React.useState(false);
    const [rejectText, setRejectText] = React.useState('');

    const clearFilter = () => {
        setFilterInputs({ bts_no: "", invoice_status: [] as string[], vendor_code: "", vendor_name: "", location: "" });
    };

    const [debouncedFilters, setDebouncedFilters] = React.useState(filterInputs);


    const { data: fetchLoction } = useGetFetchLocationQuery(0);

    React.useEffect(() => {
        if (fetchLoction?.data) {
            const list = fetchLoction?.data.map((item) => {
                return { label: item.location_txt, value: item.Location_code };
            });
            setLocationList([...list]);
        }
    }, [fetchLoction])



    React.useEffect(() => {
        const handler = setTimeout(() => {
            setDebouncedFilters(filterInputs);
        }, 500);
        return () => {
            clearTimeout(handler);
        };
    }, [filterInputs]);

    const isSearchActive = React.useMemo(
        () => !!(debouncedFilters.bts_no || debouncedFilters.invoice_status.length > 0 || debouncedFilters.vendor_name || debouncedFilters.vendor_code),
        [debouncedFilters]
    );

    const searchApiArgs = {
        bts_no: debouncedFilters.bts_no,
        vendor_name: debouncedFilters.vendor_name,
        vendor_code: debouncedFilters.vendor_code,
        location: debouncedFilters.location,
        status: debouncedFilters.invoice_status.join(","),
        page: currentPage,
        per_page: ITEMS_PER_PAGE,
        pernr: pernr,
    };

    Object.keys(searchApiArgs).forEach((key) => {
        if (searchApiArgs[key] == null || searchApiArgs[key] === "") {
            delete searchApiArgs[key];
        }
    });

    // const { data, isLoading, error: errorEmployeeInvoices, isFetching } = useGetReportsQuery(searchApiArgs);
    const { data, isLoading, error: errorEmployeeInvoices, isFetching } = useGetRejectInoiceReportsQuery(searchApiArgs);
    // const { data: rejectList } = useGetRejectInoiceReportsQuery(searchApiArgs);
    const [rejectSelectedList, { isLoading: rejectLoading }] = useGetRejectMultipleMutation();


    const displayedData = data;
    const pagination = displayedData?.pagination;

    React.useEffect(() => {
        const list = displayedData?.data?.map((item: any) => { return { ...item, checked: false }; }) || [];
        setEntries([...list]);
    }, [displayedData])

    const handlePrevPage = () => {
        setCurrentPage((prev) => Math.max(prev - 1, 1));
    };

    const handleNextPage = () => {
        if (pagination) {
            setCurrentPage((prev) => Math.min(prev + 1, pagination?.pages));
        }
    };

    const handleFilterChange = (setter: (value: any) => void, value: any) => {
        setCurrentPage(1);
        setter(value);
    };
    const handleBtsNoChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        handleFilterChange((val) => setFilterInputs((prev) => ({ ...prev, bts_no: val })), event.target.value);
    };
    const handleInvoiceStatusChange = (selectedStatusValues: string[]) => {
        handleFilterChange((val) => setFilterInputs((prevArgs) => ({ ...prevArgs, invoice_status: val })), selectedStatusValues);
    };
    const handleVendorCodeChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        handleFilterChange((val) => setFilterInputs((prev) => ({ ...prev, vendor_code: val })), event.target.value);
    };
    const handleVendorNameChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        handleFilterChange((val) => setFilterInputs((prev) => ({ ...prev, vendor_name: val })), event.target.value);
    };
    const handleLocationChange = (selectedValue: any) => {
        setFilterInputs({ ...filterInputs, location: selectedValue?.value || '' });
        setCurrentPage(1);
    };

    const onHendleSendSelectedList = async () => {
        var list = [...selectedList];
        for (let i = 0; i < list.length; i++) {
            list[i].remarks = rejectText;
        }
        try {
            const response: any = await rejectSelectedList([...list]);
            if (response?.data?.message) {
                setSelectedList([]);
                setRejectText("");
                setIsRejectOpen(false);
                toast.success(response?.data?.message)
            } else {
                toast.error(response?.error?.data?.message)
            }

        } catch (err) {
            let errorMessage = "An error occurred. " + (err?.data?.message || err?.message);
            toast.error(errorMessage);
        }
    }

    const handleCheckedAll = (e: any) => {
        const temp = [...entries];
        const list = temp?.map((item: any) => { return { ...item, checked: e.target.checked }; });
        setEntries([...list]);
        if (e.target.checked) {
            setSelectedList([...list])
        } else {
            setSelectedList([]);
        }



    }
    const handleCheckedSingle = (e: any, index: any) => {
        const temp = [...entries];
        temp[index] = { ...temp[index], checked: e.target.checked };
        setEntries([...temp]);

        const list = temp.filter((item) => item.checked);

        setSelectedList([...list])

    }


    const handleDownloadExcel = () => {
        if (startDate === '') {
            toast.error('Start date is required.');
            return;
        }
        if (endDate === '') {
            toast.error('End date is required.');
            return;
        }
        let d1 = new Date(startDate);
        let d2 = new Date(endDate);
        if (d1.getTime() > d2.getTime()) {
            toast.error('Start date not greate then end date.');
        }
        var date1 = startDate.split("-");
        var date2 = endDate.split("-");
        const formatted1 = `${date1[2]}-${date1[1]}-${date1[0]}`;
        const formatted2 = `${date2[2]}-${date2[1]}-${date2[0]}`;
        const url = apiBaseUrl + '/download-excel?start_date=' + formatted1 + '&end_date=' + formatted2 + "&pernr=" + localStorage.getItem("employee_id");

        const a = document.createElement("a");
        a.href = url;
        a.target = "_blank"
        a.click();
        URL.revokeObjectURL(url);
        setisOpen(false);
    }
    const renderFilters = () => (
        <>
            <FormControl size="sm" sx={{ width: "inherit" }}>
                <FormLabel>Search by BTS No.</FormLabel>
                <Input placeholder="BTS No." startDecorator={<SearchIcon />} value={filterInputs.bts_no} onChange={handleBtsNoChange} />
            </FormControl>
            <FormControl size="sm" sx={{ width: "inherit" }}>
                <FormLabel>Search by Vendor Name</FormLabel>
                <Input placeholder="Vendor Name" startDecorator={<SearchIcon />} value={filterInputs.vendor_name} onChange={handleVendorNameChange} />
            </FormControl>
            <FormControl size="sm" sx={{ width: "inherit" }}>
                <FormLabel>Search by Vendor Code</FormLabel>
                <Input placeholder="Vendor Code" startDecorator={<SearchIcon />} value={filterInputs.vendor_code} onChange={handleVendorCodeChange} />
            </FormControl>
            <FormControl size="sm">
                <FormLabel>Search by Location</FormLabel>
                <Autocomplete
                    style={{ width: '100%' }}
                    placeholder="Choose location"
                    options={locationList}
                    sx={{ width: 200 }}
                    onChange={(event, newInputValue) => {

                        handleLocationChange(newInputValue);
                        // handlechooseGemInvoiceMember(newInputValue, index, invoice);
                    }}
                />
            </FormControl>
            {(filterInputs?.location !== "" || filterInputs?.bts_no !== "" || filterInputs?.invoice_status?.length !== 0 || filterInputs?.vendor_code !== "" || filterInputs?.vendor_name !== "") && (
                <FormControl size="sm" sx={{ width: "inherit" }}>
                    <FormLabel>&nbsp;</FormLabel>
                    <Button onClick={clearFilter} sx={{ maxWidth: "fit-content" }} size="sm" variant="soft" color="danger">
                        <ClearIcon />
                    </Button>
                </FormControl>
            )}
        </>
    );

    if (errorEmployeeInvoices) {
        return (
            <Typography color="danger" sx={{ p: 4, textAlign: "center" }}>
                Error loading data.
            </Typography>
        );
    }

    if (isLoading) {
        return (
            <Box sx={{ display: "flex", justifyContent: "center", p: 4 }}>
                <CircularProgress />
            </Box>
        );
    }

    return (
        <React.Fragment>
            <>
                <Box sx={{ display: 'flex' }}>
                    <Box
                        className="SearchAndFilters-tabletUp"
                        sx={{
                            borderRadius: "sm",
                            // pt: 2,
                            pb: 1,
                            display: { xs: "flex", sm: "grid" },
                            flexDirection: { xs: "column", sm: "row" },
                            gridTemplateColumns: { sm: "repeat(7, 1fr)" },
                            gridTemplateRows: { sm: "repeat(1, auto)" },
                            gap: 2,
                            width: "100%",
                            flexWrap: "wrap",
                            "& > *": { minWidth: { xs: "120px", md: "160px" } },
                        }}
                    >
                        {renderFilters()}
                    </Box>
                    <Box>
                        <FormControl size="sm" sx={{ width: "inherit" }}>
                            <FormLabel>&nbsp;</FormLabel>
                            <IconButton aria-label="delete" size="lg" style={{ float: 'right' }} onClick={() => setisOpen(true)}>
                                <DownloadIcon fontSize="inherit" style={{ transform: 'scale(1.5)' }} />
                            </IconButton>
                        </FormControl>
                    </Box>
                </Box>

            </>

            <Sheet
                className="OrderTableContainer"
                variant="outlined"
                sx={{
                    width: "100%",
                    borderRadius: "sm",
                    flexShrink: 1,
                    overflow: "auto",
                    minHeight: 300,
                }}
            >
                <Table
                    aria-labelledby="tableTitle"
                    stickyHeader
                    hoverRow
                    sx={{
                        "--TableCell-headBackground": "var(--joy-palette-background-level1)",
                        "--Table-headerUnderlineThickness": "1px",
                        "--TableRow-hoverBackground": "var(--joy-palette-background-level1)",
                    }}
                >
                    <thead>
                        <tr>

                            {tableHeaders.map((headCell, index) => (
                                <>
                                    {index === 0 && <th
                                        className="heading-3"
                                        key={headCell.id}
                                        style={{
                                            width: 30,
                                            padding: "12px 10px",
                                            textAlign: "center",
                                        }}
                                    ><Checkbox onClick={(e) => handleCheckedAll(e)} checked={entries.length === selectedList.length} indeterminate={entries.length > selectedList.length && selectedList.length > 0} /></th>}
                                    <th
                                        className="heading-3"
                                        key={headCell.id}
                                        style={{
                                            width: headCell.minWidth,
                                            minWidth: headCell.minWidth,
                                            padding: "12px 6px",
                                            textAlign: "center",
                                        }}
                                    >
                                        {/*indeterminate={true}*/}

                                        <Typography fontWeight="lg" level="body-sm">

                                            {headCell.label}
                                        </Typography>
                                    </th>
                                </>
                            ))}
                        </tr>
                    </thead>
                    <tbody>
                        {isFetching ? (
                            <tr>
                                <td colSpan={tableHeaders?.length} style={{ textAlign: "center", padding: "16px" }}>
                                    <CircularProgress />
                                </td>
                            </tr>
                        ) : entries?.length === 0 ? (
                            <tr>
                                <td colSpan={tableHeaders?.length} style={{ textAlign: "center", padding: "16px" }}>
                                    <Typography>
                                        No bills found
                                        {isSearchActive ? " matching your filters." : "."}
                                    </Typography>
                                </td>
                            </tr>
                        ) : (
                            entries.map((invoice: any, index: any) => (
                                <tr key={invoice.id || invoice.bts_no}>
                                    <td style={{ textAlign: "center", paddingLeft: '11px' }}>
                                        <Checkbox checked={invoice.checked} onClick={(e) => handleCheckedSingle(e, index)} />
                                    </td>
                                    <td style={{ textAlign: "center" }}>
                                        <Typography level="body-xs">{displayOptional(invoice?.bts_no)}</Typography>
                                    </td>
                                    <td style={{ textAlign: "center" }}>
                                        <Typography level="body-xs">{displayOptional(invoice?.vendor_name)}</Typography>
                                    </td>
                                    <td style={{ textAlign: "center" }}>
                                        <Typography level="body-xs">{displayOptional(invoice?.vendor_code)}</Typography>
                                    </td>
                                    <td style={{ textAlign: "center" }}>
                                        <Typography level="body-xs">{formatDateTable(invoice?.action_date)}</Typography>
                                    </td>
                                    <td style={{ textAlign: "center" }}>
                                        <Typography level="body-xs">{displayOptional(invoice?.created_by)}</Typography>
                                    </td>
                                    <td style={{ textAlign: "center" }}>
                                        <Typography level="body-xs">{displayOptional(invoice?.gem_type)}</Typography>
                                    </td>
                                    <td style={{ textAlign: "center" }}>
                                        <Typography level="body-xs">{displayOptional(invoice?.pending_with)}</Typography>
                                    </td>
                                    <td style={{ textAlign: "center" }}>
                                        <Typography level="body-xs">{displayOptional(invoice?.entry_type)}</Typography>
                                    </td>
                                    <td style={{ textAlign: "center" }}>
                                        <Typography level="body-xs">{displayOptional(invoice?.po_num)}</Typography>
                                    </td>

                                    <td style={{ textAlign: "center" }}>
                                        <Chip
                                            size="sm"
                                            variant="soft"
                                            color={
                                                invoice.status?.toLowerCase().includes("pending")
                                                    ? "warning"
                                                    : invoice.status?.toLowerCase().includes("parked") || invoice.status?.toLowerCase().includes("submitted")
                                                        ? "primary"
                                                        : invoice.status?.toLowerCase().includes("approved") ||
                                                            invoice.status?.toLowerCase().includes("accepted") ||
                                                            invoice.status?.toLowerCase().includes("paid")
                                                            ? "success"
                                                            : invoice.status?.toLowerCase().includes("rejected") || invoice.status?.toLowerCase().includes("not parked")
                                                                ? "danger"
                                                                : "neutral"
                                            }
                                        >
                                            {displayOptional(invoice.status)}
                                        </Chip>
                                    </td>
                                    {/* <td style={{ textAlign: "center" }}>
                                        <Typography level="body-xs">{displayOptional(invoice?.paid_on)}</Typography>
                                    </td>
                                    <td style={{ textAlign: "center" }}>
                                        <Typography level="body-xs">{displayOptional(invoice?.paid_duration)}</Typography>
                                    </td> */}
                                </tr>
                            ))
                        )}
                    </tbody>
                </Table>
            </Sheet>

            <Box
                sx={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    pt: 0,
                }}
            >
                <Box></Box>
                <Box sx={{ display: "flex", gap: 1 }}>

                    <Button size="sm" variant="outlined" onClick={handlePrevPage} disabled={!pagination || pagination?.page <= 1}>
                        Previous
                    </Button>
                    <Typography level="body-sm" sx={{ mx: 1, display: 'flex', alignItems: 'center' }}>
                        Page {pagination?.page} of {pagination?.pages}
                    </Typography>
                    <Button size="sm" variant="outlined" onClick={handleNextPage} disabled={!pagination || pagination?.page >= pagination?.pages}>
                        Next
                    </Button>
                </Box>

                <Button size="sm" className="btn btn-primary" disabled={selectedList.length === 0 || rejectLoading} onClick={() => setIsRejectOpen(true)} >
                    Reject
                </Button>
            </Box>


            <Modal open={isOpen} onClose={() => setisOpen(false)}>
                <ModalDialog>
                    <DialogTitle>Download Report</DialogTitle>
                    <Stack spacing={2}>
                        <FormControl>
                            <FormLabel>Start Date</FormLabel>
                            <Input type="date" onChange={(e) => setStartDate(e.target.value)} />
                        </FormControl>
                        <FormControl>
                            <FormLabel>End Date</FormLabel>
                            <Input type="date" onChange={(e) => setEndDate(e.target.value)} />
                        </FormControl>
                        <Button onClick={() => handleDownloadExcel()}>Download</Button>
                    </Stack>
                </ModalDialog>
            </Modal>
            <Modal open={isRejectOpen} onClose={() => setIsRejectOpen(false)}>
                <ModalDialog>
                    {/* <DialogTitle>Remarks:</DialogTitle> */}
                    <Stack spacing={2}>
                        <TextareaInput
                            name="remarks"
                            label="Remarks"
                            value={rejectText}
                            maxLength={500}
                            onChange={(e) => setRejectText(e.target.value)}
                            placeholder="Enter remarks"
                            minRows={2}
                        // formControlSx={{ gridColumn: { xs: "1", sm: "1 / -1" } }}
                        />
                        <Button disabled={rejectText === ''} onClick={() => onHendleSendSelectedList()}>Submit</Button>
                    </Stack>
                </ModalDialog>
            </Modal>
        </React.Fragment>
    );
}
